import { IonContent, IonPage, useIonViewWillEnter } from "@ionic/react";
import React, { useContext, useState } from "react";

import {
  Context,
  fetchCareerFeedbackQuestionsHistories,
} from "../../../store/student";
import FabButton from "../../../atoms/FabButton";
import FiltableHeader from "../../../organisms/FiltableHeader";
import RealizationCareer from "../../../templates/RealizationCareer";
import styles from "../common.module.scss";

const RealizationCareerPage = () => {
  const { dispatch } = useContext(Context);

  useIonViewWillEnter(() => {
    dispatch(fetchCareerFeedbackQuestionsHistories());
  });

  const [state, setState] = useState({
    searching: false,
    searchText: "",
  });

  return (
    <IonPage>
      <FiltableHeader
        title="キャリア開拓モード"
        unreadNotiCount={0}
        searching={state.searching}
        searchText={state.searchText}
        setState={setState}
        goBack
      />
      <IonContent className={styles.wrapper}>
        <div className={styles.container}>
          <RealizationCareer state={state} />
        </div>
      </IonContent>
      <FabButton />
    </IonPage>
  );
};

export default RealizationCareerPage;
